import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import '../../css/users/usersPageHeader.css';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';

const UsersPageHeader = ({setOpenAddUser}) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasUserCreatePermission = useHasPermission('user_create');

    const handleAddUser = useCallback(() => {
        setOpenAddUser(true);
    }, [setOpenAddUser]);

    return (
        <Box className='users_page_header_main_container'>
            <Box className='users_page_header_title_box'>
                <Typography className='users_page_header_page_title'>{t("Utilisateurs")}</Typography>
            </Box>
            {isDesktop && hasUserCreatePermission &&
                <Box className='users_page_header_action_box' onClick={handleAddUser}>
                    <Iconify className='users_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='users_page_header_action_title'>{t("addUserDialogeTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='users_page_header_action_box'>
                    {hasUserCreatePermission && <Iconify className='users_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddUser} />}
                </Box>
            }
        </Box>

    );
};

export default React.memo(UsersPageHeader);